import { createContext } from 'react';

import RootStore from './rootStore';

export default createContext(new RootStore());